// extracted by mini-css-extract-plugin
export default {"carousel-container":"ListingsCarousel_carousel-container__r9M5x","carousel":"ListingsCarousel_carousel__Juh61"};